import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class FilterComponent extends Vue {

    @Prop()
    filterHeader!: string;

    @Prop()
    filterItems!: any[];

    @Prop()
    filterModel!: any[];

    @Prop({ default: 'name' })
    filterItemValue!: string;

    selectedFilters: any[] = this.filterModel;

    isShown: boolean = false

    isChecked(item: any) {
        return this.selectedFilters.indexOf(item[this.filterItemValue]) !== -1;
    }

    @Watch('filterModel')
    onFilterModelChanged(newVal: string[]) {
        this.selectedFilters = newVal;
    }

    @Watch('selectedFilters')
    onSelectedFiltersChanged(newVal: string[]) {
        this.$emit('update:filterModel', newVal)
    }

    toggleCheckbox(itemName: string) {
        if (this.selectedFilters.indexOf(itemName) === -1) {
            this.selectedFilters.push(itemName);
        }
        else {
            this.selectedFilters.splice(this.selectedFilters.indexOf(itemName), 1);
        }
    }
}
